<!--
  Copyright 2026 Tecnalia, Basque Research & Technology Alliance (BRTA)

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at
 
     http://www.apache.org/licenses/LICENSE-2.0
 
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
 
   SPDX-License-Identifier: Apache-2.0
-->

<div class="role-placeholder">
	<div class="role-content">
		@if (this.role === 'General') {
			<h3>{{ 'ROLE.WELCOME' | translate }}<b id="role-text">{{ 'ROLE.CATALOG' | translate }}</b></h3>

			<div 
				class="info-cards"
				[style.gridTemplateColumns]="'repeat(' + getVisibleCardsCount() + ', 1fr)'"
			>

				@if (isAdmin) {
					<div class="card" id="provider-card">
						<div class="card-body">
							{{ 'ROLE.ACCESS' | translate }}
							<b id="role-text">{{ 'HEADER.ADMINISTRATOR' | translate }}</b>
							{{ 'ROLE.ADMINISTRATOR-TAB' | translate }}
						</div>
					</div>
				}

				<div class="card" id="consumer-card">
					<div class="card-body">
						{{ 'ROLE.ACCESS' | translate }}
						<b id="role-text">{{ 'HEADER.CATALOG' | translate }}</b>
						{{ 'ROLE.CATALOG-TAB' | translate }}
					</div>
				</div>

			</div>
		} @else {
			<h3>{{ 'ROLE.ERROR' | translate }}</h3>
		}
	</div>
</div>